import * as actions from './unassign-all-modal.actions';

const initialState = {
  isUnassignModalOpen: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.HIDE_UNASSIGN_MODAL:
      return {
        ...state,
        isUnassignModalOpen: false
      };

    case actions.SHOW_UNASSIGN_MODAL:
      return {
        ...state,
        isUnassignModalOpen: true
      };
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./components/unassign-all-modal/store/unassign-all-modal.reducer.js